export default __webpack_public_path__ + "static/media/Shaka_particle_final_09.4de6f270.png";